export default __webpack_public_path__ + "static/harvest-hush-logo-b84bac7ad215eff7b82bb21c36f1c264.svg";